import { GET_PAGES } from 'actionTypes'

const defaultState = {
  pages: 0,
  count: 0,
  current: 1,
  counter: 0,
}

const paginate = (state = defaultState, action) => {
  switch (action.type) {
    case GET_PAGES:
      const actionCounter = action.counter

      if (
        !actionCounter ||
        typeof actionCounter === 'object' ||
        actionCounter > state.counter
      ) {
        return {
          ...state,
          pages: action.pages,
          current: action.current,
          count: action.count,
          counter: action.counter || 0,
        }
      }
      return state
    default:
      return state
  }
}

export default paginate
